module.exports = __webpack_public_path__ + "static/img/8ways_sc.211a12b2.png";